import { render } from "./HZButton.vue?vue&type=template&id=6a42f997&scoped=true"
import script from "./HZButton.vue?vue&type=script&lang=js"
export * from "./HZButton.vue?vue&type=script&lang=js"

import "./HZButton.vue?vue&type=style&index=0&id=6a42f997&scoped=true&lang=css"

import exportComponent from "C:\\Develop\\web\\notigo_base\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a42f997"]])

export default __exports__